import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import InputField from 'src/common/formFields/InputField';

export default function AdditionalDetailsForm(props) {
  const {
    formField: {
      deliveredDipQuantity,
      deliveredMeasuredQuantityFLS,
      deliveredMeasuredQuantityMeter,
      temperatureDuringLoading,
      temperatureDuringUnloading,
      spillageQuantity,
      shortageQuantity,
      densityDuringLoading,
      densityDuringUnloading,
    },
    requiredHintText,
    volumeUnitLabel = 'Litres'
  } = props;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <InputField name={deliveredDipQuantity.name} label={`${deliveredDipQuantity.label}${volumeUnitLabel ? ` (${volumeUnitLabel})` : ''} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={deliveredMeasuredQuantityFLS.name} label={`${deliveredMeasuredQuantityFLS.label}${volumeUnitLabel ? ` (${volumeUnitLabel})` : ''} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={deliveredMeasuredQuantityMeter.name} label={`${deliveredMeasuredQuantityMeter.label}${volumeUnitLabel ? ` (${volumeUnitLabel})` : ''} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={temperatureDuringLoading.name} label={`${temperatureDuringLoading.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={temperatureDuringUnloading.name} label={`${temperatureDuringUnloading.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={spillageQuantity.name} label={`${spillageQuantity.label}${volumeUnitLabel ? ` (${volumeUnitLabel})` : ''} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={shortageQuantity.name} label={`${shortageQuantity.label}${volumeUnitLabel ? ` (${volumeUnitLabel})` : ''} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={densityDuringLoading.name} label={`${densityDuringLoading.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={densityDuringUnloading.name} label={`${densityDuringUnloading.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
    </Grid>
  );
}

AdditionalDetailsForm.propTypes = {
  formField: PropTypes.object.isRequired,
  requiredHintText: PropTypes.string,
  volumeUnitLabel: PropTypes.string
};
